<template>
    <v-dialog
      v-model="visible"
      width="500"
    >
      <v-card class="qr-preview">
        <div class="close-btn" @click="onClose">X</div>
        <v-img width="490" :src="image" alt="qrCode" />
      </v-card>
    </v-dialog>
</template>
<script>
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import Vue from 'vue';

@Component
export default class QrPreview extends Vue {
  @Prop({
    String,
  }) image;

  @Prop({ Boolean, default: false }) visible;

  clearOwnData() {
    this.valid = false;
    this.menu = null;
    this.saleZone = null;
    this.linkTree = null;
    this.useLinkTree = false;
    this.number = 0;
  }

  onClose() {
    this.$emit('onClose');
  }
}
</script>
<style>
.close-btn {
  position: absolute;
  top: 0;
  right: 12px;
  font-weight: bold;
  cursor: pointer;
  z-index: 1;
  font-size: 30px;
  text-transform: lowercase;
}
.qr-preview {
  position: relative;
}
</style>
